@if (mode === 'inline') {
<div class="inline-upload" [class.inline-upload--has-file]="files.length > 0">
  @if (files.length > 0) {
  @for (uploadedFile of files; track uploadedFile.name; let index = $index) {
  <div class="inline-upload__file-row">
    <span class="inline-upload__file-icon">
      <mat-icon svgIcon="file"></mat-icon>
    </span>
    <div class="inline-upload__file-meta">
      <span class="inline-upload__file-name">{{ uploadedFile.name }}</span>
      <span class="inline-upload__file-size">{{ (uploadedFile.size / (1024 * 1024)).toFixed(2) }} MB</span>
    </div>
    <button type="button" class="inline-upload__remove-btn" (click)="removeFile(index)" aria-label="Remove file">
      <mat-icon svgIcon="trash"></mat-icon>
    </button>
  </div>
  }
  }

  @if (files.length === 0 || multiple) {
  <div class="inline-upload__drop-zone" [class.inline-upload__drop-zone--active]="isDragging"
    (dragover)="isDragging = true; $event.preventDefault()" (dragleave)="isDragging = false" (drop)="onDrop($event)">
    <div class="inline-upload__content">
      <img src="assets/icons/drop-file-icon.svg" alt="drop-file" class="inline-upload__image">
      <p class="inline-upload__text">Drop your files here or
        <label class="inline-upload__browse">Browse Files
          <input type="file" hidden [accept]="acceptedExtensions" [attr.multiple]="multiple ? '' : null"
            (change)="onBrowse($event)">
        </label>
      </p>
      <span class="inline-upload__hint">{{ dropZoneHint }}</span>
    </div>
  </div>
  }

  @if (errorMessage) {
  <span class="inline-upload__error">{{ errorMessage }}</span>
  }
</div>
} @else {
<div class="upload-passport" [class.has-file]="file">

  @if(file){
  <div class="file-uploaded">
    <span class="file-icon"><mat-icon matPrefix [svgIcon]="'file'" /></span>
    <div class="file-info">
      <p class="file-name">File name</p>
      <p class="file-size">1mb</p>
    </div>
    <button (click)="removeFile()">
      <mat-icon matPrefix [svgIcon]="'trash'" class="trash" />
    </button>
  </div>
  }
  @else{
  <div class="upload-actions">
    <button mat-stroked-button class="upload" (click)="open = true">
      <mat-icon matPrefix [svgIcon]="'upload'" />
      <span>
        Upload passport to pre-fill
      </span>
    </button>
    <app-tooltip [text]="'PREFERENCE_FORM.PASSPORT_INFO'" position="above">
      <mat-icon matPrefix [svgIcon]="'icon-help-circle'"></mat-icon>
    </app-tooltip>
  </div>
  }
</div>

}

@if (open) {
<button type="button" class="backdrop" aria-label="Close upload modal" (click)="open = false"></button>

<div class="modal">
  <mat-card class="modal-container">
    <mat-card-header class="modal-header">
      <mat-card-title class="title">
        <mat-icon btn-icon-end svgIcon="file-upload" class="icon"></mat-icon>
        <span>Upload Passport</span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="modal-content">
      <div class="upload-content">
        <div class="drop-zone" [class.dragging]="isDragging" (dragover)="isDragging = true; $event.preventDefault()"
          (dragleave)="isDragging = false" (drop)="onDrop($event)">
          <div class="drop-area">
            <img src="../../../assets/icons/drop-file-icon.svg" alt="drop-file">

            <div class="drop-text">
              <p>Drop file here or</p>


              <label class="browse">
                Browse
                <input type="file" hidden (change)="onBrowse($event)" />
              </label>
            </div>
          </div>
          <div class="line"></div>

          <ul>
            <li>Accepted pages: Front (Passport)</li>
            <li>Accepted formats: JPG, PNG, PDF</li>
            <li>Maximum size: 2MB</li>
            <li>Ensure passport details are clearly visible</li>
          </ul>
        </div>
        @if (file) {

        <div class="progress">
          <div class="progress-container">
            <div class="file-container">
              <div class="file">
                <span class="file-icon"><mat-icon matPrefix [svgIcon]="'upload'" class="upload" /></span>
                <div class="file-info">
                  <p class="file-name">File name</p>
                  <p class="file-size">1mb</p>
                </div>
              </div>
              <div class="file-action">
                <div>
                  <mat-icon matPrefix [svgIcon]="'tick'" />
                </div>
                <button class="trash" (click)="removeFile()">
                  <mat-icon matPrefix [svgIcon]="'trash'" class="trash" />
                </button>
              </div>

            </div>
            <div class="bar" [style.width.%]="progress"></div>
          </div>
          <div class="line"></div>
          <app-buttons [label]="'Extraction Information'" (clicked)="onExtractClick()">
            <mat-icon btn-icon-start svgIcon="extract" class="icon"></mat-icon>
          </app-buttons>
        </div>

        <div class="Personal-Info">

          <p>
            Retrieved Info
          </p>


          <div class="primary-Applicant">

            <div>
              <app-input [placeholder]="'Enter a name'" [required]="true"
                [externalLabel]="'PREFERENCE_FORM.FIRST_NAME' | i18nTranslate" controlName="firstName1" [isEdit]="true">
              </app-input>
            </div>
            <div>
              <span class="dropdown-label">
                {{'PREFERENCE_FORM.LAST_NAME' | i18nTranslate}}
                <span class="required-asterisk">*</span>
              </span>
              <app-input controlName="lastName2" [isEdit]="true">
              </app-input>
            </div>
            <div class="insurance-for">
              <span class="dropdown-label">
                {{'PREFERENCE_FORM.GENDER' | i18nTranslate}}
                <span class="required-asterisk">*</span>
              </span>
              <app-radio-button formControlName="gender" name="gender" [required]="true" [options]="[
          { label: 'Male', value: 'male'},
          { label: 'Female', value: 'female' },
          { label: 'Others', value: 'others' }
        ]">
              </app-radio-button>
            </div>
            <div class="date">
              <app-datepicker [datepickerIcon]="'suffix'" controlName="dob" [required]="true"
                aria-placeholder="dd/mm/yyyy" [label]="'PREFERENCE_FORM.DOB' | i18nTranslate">
              </app-datepicker>
            </div>
          </div>
        </div>
        }
      </div>
    </mat-card-content>

    <mat-card-actions class="modal-footer">
      <app-checkbox label="I consent to the secure collection, storage and processing 
    of my personal data."></app-checkbox>
      <!-- change variant for cancel -->
      <app-buttons [label]="'Cancel'" [variant]="'tertiary'" (clicked)="closeModal()"></app-buttons>
      <app-buttons [label]="'Add'" [disabled]="true">
      </app-buttons>
    </mat-card-actions>
  </mat-card>
</div>
}